import { ColumnHeadersVariant } from 'libs/ui/Table/types';
import { CSSObject } from 'styled-components';

import { styled } from '../styled';
import { Colors } from '../theme';

import { COLUMN_HEADER_TITLE_FONT_SIZES } from './styles';

interface Props {
  isCellClickable: boolean;
  overlayWrapperHeight?: number;
  columnHeadersVariant?: ColumnHeadersVariant;
  isError?: boolean;
}

export const TableStyled = styled('div')<Props>(
  ({
    theme,
    isCellClickable,
    overlayWrapperHeight = 156,
    columnHeadersVariant = 'standard',
    isError,
  }) => ({
    width: '100%',
    position: 'relative',

    '.table-dataGrid': {
      borderRadius: 8,

      border: isError ? `1px solid ${Colors.red500}` : 'none',
      background: Colors.white,

      '.table-main': {
        overflow: 'unset',
      },

      '.table-virtualScroller': {
        marginTop: '0!important',
      },

      '.table-columnHeaders': {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        background: Colors.blue50,
        height: 40,

        borderRadius: 8,
        border: 'none',

        '.table-columnHeaderTitle': {
          fontSize: COLUMN_HEADER_TITLE_FONT_SIZES[columnHeadersVariant],
          fontWeight: 400,
          color: Colors.gray600,
        } as CSSObject,

        '.table-columnSeparator': {
          display: 'none',
        } as CSSObject,

        '.MuiDataGrid-columnHeader--sortable': {
          '&:hover': {
            background: Colors.blue100,
          },
        },
      } as CSSObject,

      '.table-cell': {
        ...theme.typography.body,

        borderColor: Colors.gray200,
      },

      '.table-row:hover': {
        cursor: isCellClickable ? 'pointer' : 'auto',
        backgroundColor: isCellClickable ? Colors.blue100 : 'inherit',
      },

      '.table-row-link': {
        color: 'inherit',
      },

      '.MuiDataGrid-cell.MuiDataGrid-withBorderColor': {
        borderBottom: `1px solid  ${Colors.gray200}`,
      },

      '.table-row--lastVisible .MuiDataGrid-cell.MuiDataGrid-withBorderColor': {
        borderBottom: 0,
      },

      '.table-columnHeader, .table-cell': {
        padding: '0 12px',
      } as CSSObject,

      '.table-columnHeader:focus, .table-cell:focus, .table-columnHeader:focus-within, .table-cell:focus-within':
        {
          outline: 'none',
        } as CSSObject,

      '.table-row--lastVisible .table-cell': {
        borderBottom: 0,
        minHeight: 70,
      } as CSSObject,
      '.table-row--lastVisible': {
        minHeight: 70,
      } as CSSObject,

      '.table-footerContainer': {
        borderColor: Colors.gray200,
        height: 66,
      } as CSSObject,
    } as CSSObject,

    '.table-overlayWrapper': {
      minHeight: overlayWrapperHeight,
      ...theme.typography.bodyMedium,
      color: isError ? Colors.red500 : undefined,
    } as CSSObject,
  })
);
